// extracted by mini-css-extract-plugin
module.exports = {"boxLabel":"style_boxLabel__J90ks","pid":"style_pid__3tos2","pathway":"style_pathway__3LlP_"};